module.exports = __webpack_public_path__ + "img/avatar-female.e70cee3c.png";